import { render } from "./CommunityManagement.vue?vue&type=template&id=f79cf594&scoped=true"
import script from "./CommunityManagement.vue?vue&type=script&lang=js"
export * from "./CommunityManagement.vue?vue&type=script&lang=js"

import "./CommunityManagement.vue?vue&type=style&index=0&id=f79cf594&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79cf594"]])

export default __exports__